// Mapa das telas do painel: usado pelo menu lateral (desktop e drawer), pela
// barra inferior do app e pelo título da barra de topo no celular.

import {
  LayoutDashboard,
  Smartphone,
  Bug,
  Activity,
  FileText,
  Users,
  Settings,
  Layers,
  Wallet,
  LifeBuoy,
  ShieldCheck,
  Briefcase,
  Calculator,
  Bell,
  Receipt,
} from 'lucide-react';
import type { Permission } from '@/api/endpoints/auth';

export interface NavItem {
  path: string;
  label: string;
  /** Rótulo curto da barra inferior (cabe embaixo do ícone). */
  curto?: string;
  icon: typeof LayoutDashboard;
  permission: Permission;
}

export const menuGroups: { title?: string; items: NavItem[] }[] = [
  {
    items: [
      {
        path: '/',
        label: 'Dashboard',
        curto: 'Início',
        icon: LayoutDashboard,
        permission: 'dashboard',
      },
      { path: '/devices', label: 'Dispositivos', icon: Smartphone, permission: 'devices' },
    ],
  },
  {
    title: 'Monitoramento',
    items: [
      { path: '/uptime', label: 'Uptime', icon: Activity, permission: 'uptime' },
      {
        path: '/errors',
        label: 'Erros & Crashes',
        curto: 'Erros',
        icon: Bug,
        permission: 'errors',
      },
      {
        path: '/logs',
        label: 'Logs do Sistema',
        curto: 'Logs',
        icon: FileText,
        permission: 'logs',
      },
    ],
  },
  {
    title: 'Gestão',
    items: [
      { path: '/admin', label: 'Usuários', icon: Users, permission: 'users' },
      { path: '/plans', label: 'Planos', icon: Layers, permission: 'plans' },
      { path: '/financas', label: 'Finanças', icon: Wallet, permission: 'finance' },
      { path: '/cobrancas', label: 'Cobranças', icon: Receipt, permission: 'finance' },
      { path: '/suporte', label: 'Suporte', icon: LifeBuoy, permission: 'support' },
      {
        path: '/contratacoes',
        label: 'Contratações',
        curto: 'Vagas',
        icon: Briefcase,
        permission: 'careers',
      },
      { path: '/orcamentos', label: 'Orçamentos', icon: Calculator, permission: 'orcamentos' },
      {
        path: '/notificacoes',
        label: 'Notificações',
        curto: 'Avisos',
        icon: Bell,
        permission: 'notifications',
      },
    ],
  },
  {
    title: 'Sistema',
    items: [
      { path: '/equipe', label: 'Equipe', icon: ShieldCheck, permission: 'team' },
      {
        path: '/settings',
        label: 'Configurações',
        curto: 'Ajustes',
        icon: Settings,
        permission: 'settings',
      },
    ],
  },
];

export const todasAsTelas: NavItem[] = menuGroups.flatMap((g) => g.items);

// Ordem de preferência da barra inferior: o que mais se usa no celular vem
// primeiro. Entram as 4 primeiras que o cargo permite; o resto fica no "Menu".
const PRIORIDADE_BARRA = [
  '/',
  '/suporte',
  '/admin',
  '/financas',
  '/errors',
  '/devices',
  '/orcamentos',
];

export function itensDaBarra(pode: (p: Permission) => boolean): NavItem[] {
  return PRIORIDADE_BARRA.map((path) => todasAsTelas.find((t) => t.path === path))
    .filter((t): t is NavItem => !!t && pode(t.permission))
    .slice(0, 4);
}

export function tituloDaRota(pathname: string): string {
  if (pathname === '/trocar-senha') return 'Trocar senha';
  const tela = todasAsTelas.find((t) => t.path === pathname);
  return tela?.label ?? 'Curral Tech';
}
